
import { Component, Vue } from 'vue-property-decorator';
import MainNav from '@/components/MainNav.vue';
import Welcome from '@/page-sections/Welcome.vue';
import Projects from '@/page-sections/Projects.vue';
import WhatIDo from '@/page-sections/WhatIDo.vue';
import GetInTouch from '@/page-sections/GetInTouch.vue';

@Component({
    components: {
        MainNav,
        Welcome,
        Projects,
        WhatIDo,
        GetInTouch,
    },
})
export default class App extends Vue {
    private section: string = 'welcome';

    private lastScrollPosition: number = 0;
    private scrollDirection: 'up' | 'down' = 'up';

    private get currentYear() {
        return new Date().getFullYear();
    }

    /**
     * As each page section comes into view, check that its top is touching or above the top of the viewport.
     * As soon as it is:
     *
     *  1. Set the section property to match the section's id
     *  2. Set the meta[name=theme-color].content to match the css value of the section's background-color
     *
     */
    private mounted() {

        // first listen to scrolls so we can record the direction
        window.addEventListener('scroll', () => {
            this.scrollDirection = (this.lastScrollPosition - window.scrollY) < 0 ? 'down' : 'up';
            this.lastScrollPosition = window.scrollY;
        });

        // now observe the page sections so we can set the correct nav item to active based on our position
        const navObserver = new IntersectionObserver((entries, observer) => {
            for (const entry of entries) {
                if (entry.intersectionRatio > 0.5) {
                    // if the ratio is greater than our threshold, then it is the incoming section
                    this.section = entry.target.id;
                }
            }
        }, { root: null, rootMargin: '0px', threshold: 0.5 });

        // next observer the incoming sections, and based on the scroll direction,
        // set the chrome color to match the section color
        const colorScrollObserver = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.intersectionRect.top === 0 && entry.intersectionRatio > 0) {
                    let bg;
                    if (this.scrollDirection === 'up') {
                        // scrolling up so set the color to the intersection section's color
                        bg = getComputedStyle(entry.target).backgroundColor;
                    } else {
                        // scrolling down, so entry must be the outgoing section. Set the color to
                        // match the *next* section's
                        const nextSection = entry.target.nextSibling;
                        if (nextSection !== null) {
                            bg = getComputedStyle(nextSection as Element).backgroundColor;
                        }
                    }

                    const meta = document.querySelector('meta[name=theme-color') as HTMLMetaElement | null;
                    if (meta !== null && bg !== null && bg !== undefined) {
                        meta.content = bg;
                    }

                    // update the nav color to match, but only on small screens
                    if (window.outerWidth <= 640) {
                        const nav = document.getElementById('nav') as HTMLDivElement | null;
                        if (nav !== null && bg !== null && bg !== undefined) {
                            nav.style.setProperty('--nav-bg', bg);
                        }
                    }
                }
            }
        }, { threshold: 0.01, rootMargin: '0px' });

        for (const element of document.getElementsByClassName('page-section')) {
            navObserver.observe(element);
            // colorScrollDownObserver.observe(element);
            colorScrollObserver.observe(element);
        }
    }

    /**
     * Scroll the window to which ever section was navigated to, and set the section property accordingly
     * @param section
     */
    private navigate(section: string) {
        // first find out if this is even a valid navigation
        const element = document.getElementById(section);

        if (element !== null) {
            // if it is, just scroll to it
            const rect = element.getBoundingClientRect();
            const top = rect.top + window.scrollY;

            window.scrollTo({
                top,
                behavior: 'smooth',
            });
        }
    }


}
